import React, { useState } from 'react';
import Media from 'react-media';
import { HeaderDesktop } from '../../components/header/desktop/HeaderDesktop';
import { HeaderMobile } from '../../components/header/mobile/HeaderMobile';
import { Button, TextField } from '@material-ui/core';
import "./CreateNewApp.scss";

function CreateNewApp(props: any) {
  const [initAppName, setInitAppName] = useState('');
  const [initAppSite, setInitAppSite] = useState('');
  const [activeCta, setActiveCta] = useState(true);

  const renderDesktopHeader = () => {
    return (
      <HeaderDesktop specificPath={'/'} showBackText showBack showLogout={false} showTitle={true} title="CREA UNA NUOVA APPLICAZIONE" />
    );
  }

  const renderMobileHeader = () => {
    return (
      <HeaderMobile specificPath={'/'} showBack={true} showLogout={true} showTitle={true} title="CREA UNA NUOVA APPLICAZIONE" />
    );
  }

  const handleName = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nameApp = event.target.value;
    setInitAppName(nameApp);
    handleValidate();
  }

  const handleSite = (event: React.ChangeEvent<HTMLInputElement>) => {
    const appSite = event.target.value;
    setInitAppSite(appSite);
    handleValidate();
  }

  const handleValidate = () => {
    if (initAppName.length > 0 && initAppSite.length > 0) {
      setActiveCta(false);
    } else {
      setActiveCta(true);
    }
  }

  const goToNext = () => {
    // INSERISCI ROTTA
    props.history.push("/assignApp", {
      headerTitle: "CREA UNA NUOVA APPLICAZIONE",
      title: `Seleziona i punti vendita per utilizzare i relativi TID tramite le chiavi della specifica applicazione`,
      data: {
        appName: initAppName,
        appSite: initAppSite,
      },
      createNewApp: true
    });
  }

  return (
    <div id="main-container-create-app">
      <Media query="(max-width: 1064px)" render={() => renderMobileHeader()} />
      <Media query="(min-width: 1065px)" render={() => renderDesktopHeader()} />
      <div className="create-app-container">
        <p className="create-app-title">Inserisci il nome dell'applicazione</p>
        <div className="create-app-content">
          <div className="create-app-field">
            <TextField
              id="appName"
              label="Nome"
              value={initAppName}
              onChange={handleName}
            />
          </div>
          <div className="create-app-field">
            <TextField
              id="appSite"
              label="Redirect URI"
              value={initAppSite}
              onChange={handleSite}
            />
          </div>
        </div>
        <div className="form-elements">
          <Button
            disabled={activeCta}
            className={"change-password-submit-button"}
            type={"submit"}
            onClick={goToNext}
          >
            AVANTI
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CreateNewApp